{
  "sdk-download-android": "Download til Android",
  "sdk-connect": "Forbind",
  "sdk-download-ios": "Download til iOS",
  "sdk-install": "Installer",
  "sdk-modal-instruct-1": "1. Åbn Binance-appen",
  "sdk-modal-instruct-2": "2. Tryk på {{icon}} på startskærmen",
  "sdk-modal-title": "Forbind til Binance",
  "sdk-no-app": "Har du ikke Binance-appen endnu?"
}